export default [
  {
    name: 'global-views/user-cancellation-survey',
    path: '/cancellation-survey?:username',
  },
];
